import { ReactNode } from 'react';

import {
   ButtonVariant,
   ContentNode,
   ContentNodeRenderer,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
   ShowModalEventInterceptor,
   useHistoryPushWithBackAction,
} from '@dreryk/react-components';
import { TranslatableText } from '@dreryk/react-common';

import { translationKeys } from '../translations';
import { useVideoConsultationGlobalState } from '../shared/useVideoConsultationGlobalState';

type VideoConsultationConflictShowEventInterceptorProps = {
   readonly appointmentId: number;
   readonly children: ReactNode;
   readonly content: ContentNode;
   readonly confirmButtonLabel: TranslatableText;
};

export const VideoConsultationConflictShowEventInterceptor = (
   props: VideoConsultationConflictShowEventInterceptorProps
): JSX.Element => {
   const push = useHistoryPushWithBackAction(true);
   const { state } = useVideoConsultationGlobalState();
   const backAction = state.type === 'inCall' && state.window.backAction ? state.window.backAction : null;

   return (
      <ShowModalEventInterceptor
         testId={'videoConsultationConflict'}
         shouldShowModal={state.type === 'inCall' && state.originId !== props.appointmentId}
         title={translationKeys.youHaveOngoingVideoCall}
         content={({ resolve, reject }) => {
            return (
               <>
                  <ContentNodeRenderer node={props.content} />
                  <ModalCancelButton onClick={reject} />
                  <ModalCloseButton onClick={reject} />
                  {backAction ? (
                     <ModalConfirmButton
                        label={backAction.toOriginLabel}
                        onClick={() => {
                           push(backAction.location.path, backAction.location.state ?? {});
                        }}
                        variant={ButtonVariant.SECONDARY}
                     />
                  ) : null}
                  <ModalConfirmButton label={props.confirmButtonLabel} onClick={resolve} />
               </>
            );
         }}
         modalWidth={ModalWidth.WIDE}
         footerItemsHidden
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
